const DEFAULT_PUBLIC_URL = "https://deepface.dev";
const CANONICAL_HOST = "deepface.dev";
const LEGACY_HOST = "www.deepface.dev";

function stripTrailingSlash(value: string) {
  return value.replace(/\/+$/, "");
}

export function canonicalizePublicUrl(raw: string): string {
  try {
    const url = new URL(raw);

    if (url.hostname.toLowerCase() === LEGACY_HOST) {
      url.hostname = CANONICAL_HOST;
    }

    url.pathname = stripTrailingSlash(url.pathname);
    return stripTrailingSlash(url.toString());
  } catch {
    return DEFAULT_PUBLIC_URL;
  }
}

export function resolvePublicSiteUrl(windowOrigin?: string): string {
  const preferred =
    process.env.NEXT_PUBLIC_SITE_URL ||
    process.env.NEXT_PUBLIC_APP_URL ||
    process.env.PUBLIC_URL;

  if (preferred) {
    return canonicalizePublicUrl(preferred);
  }

  if (windowOrigin) {
    return canonicalizePublicUrl(windowOrigin);
  }

  return DEFAULT_PUBLIC_URL;
}

export function buildPublicSiteUrl(path: string, windowOrigin?: string): string {
  const base = resolvePublicSiteUrl(windowOrigin);
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}
